/**
 * The unicode value for the apple command key.
 */
export const APPLE_COMMAND_KEY = '\u2318';
//# sourceMappingURL=constants.js.map